import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { CustomFields, Shipment } from '../../../pages/overview/models/shipment';

@Injectable({
  providedIn: 'root'
})
export class ShipmentDetailsService {
  constructor(private http: HttpClient) {}

  getShipmentBy(shipmentNumber: string, isArchived: boolean) {
    const url = isArchived ? 'archive/shipments' : 'shipments';
    return this.http.get<Shipment>(`${environment.apiUrl}/${url}/${shipmentNumber}`);
  }

  watched(shipmentNumber: string, watched: boolean) {
    return this.http.put(`${environment.apiUrl}/shipments/${shipmentNumber}/watched`, { watched });
  }

  updateCustomFields(shipmentNumber: string, data: CustomFields) {
    return this.http.put(`${environment.apiUrl}/shipments/customFields`, {
      shipmentNumbers: [shipmentNumber],
      data
    });
  }
}
